

// @mui material components
import Card from "@mui/material/Card";

// Dashboard React components
import DSBox from "components/DSBox";
import DSTypography from "components/DSTypography";
import DSButton from "components/DSButton";

// Billing page components
import Invoice from "layouts/billing/components/Invoice";

function Invoices() {
  return (
    <Card id="delete-account">
      <DSBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <DSTypography variant="h6" fontWeight="medium">
          Invoices
        </DSTypography>
        <DSButton variant="outlined" buttonColor="info" size="small">
          view all
        </DSButton>
      </DSBox>
      <DSBox p={2}>
        <DSBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
        <Invoice date="August, 25, 2022" id="#MS-41466" price="$1180" />
        <Invoice date="July, 10, 2022" id="#RV-126729" price="$2510" />
          <Invoice date="June, 01, 2022" id="#MS-412646" price="$1810" />          
          <Invoice date="April, 05, 2022" id="#QW-193578" price="$1210" />
        </DSBox>
      </DSBox>
    </Card>
  );
}

export default Invoices;
